import { DesktopNav } from './DesktopNav'
import { Logo } from './Logo'
import { MobileNav } from './MobileNav'
import { SocialList as Social } from './Social'
import { StarRating } from './StarRating'
import { UserMenu } from './UserMenu'
import { Wrapper } from './Wrapper'

export const PageHeader = {
  Logo: Logo,
  Wrapper: Wrapper,
  Social: Social,
  StarRating: StarRating,
  UserMenu: UserMenu,
  DesktopNav: DesktopNav,
  MobileNav: MobileNav
}
